import { IconProps, createIcon as chakraCreateIcon } from '@chakra-ui/icons'
import { ReactElement, createElement, isValidElement } from 'react'

type CreateIconOptions = {
  viewBox?: string
  path?: ReactElement | ReactElement[]
  d?: string
  displayName?: string
  defaultProps?: IconProps
}

const addKeysToChildren = (children: ReactElement[]): ReactElement[] =>
  children.map((child, i) => {
    if (!isValidElement(child)) return child
    if (child.key != null) return child
    return createElement(child.type, { ...child.props, key: String(i) })
  })

/**
 * Workaround wrapper around Chakra's `createIcon`.
 *
 * React 19 tightened key handling, so passing keyless children to Chakra's
 * `createIcon` now triggers warnings/errors. `@chakra-ui/icons` (pinned at
 * 2.2.4) is unmaintained and won't be patched, so we re-key the path
 * children here before delegating.
 *
 * Remove this wrapper when we upgrade to Chakra v3 — `createIcon` moves
 * out of `@chakra-ui/icons` entirely and handles this natively.
 */
export const createIcon = (options: CreateIconOptions) => {
  if (Array.isArray(options.path)) {
    return chakraCreateIcon({
      ...options,
      path: addKeysToChildren(options.path) as any,
    })
  }
  return chakraCreateIcon(options)
}
